<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected" @change="change"></Tabs>
		<div class="padding-top padding-right text-right initial-toolbar">
			<Button @click="openImport">导入</Button>
			<Button @click="exportData">导出</Button>
			<Button @click="clearData">清空</Button>
			<Button color="primary" @click="trialBalance">试算平衡</Button>
			<Button color="primary" @click="openCashFlow">现金流期初</Button>
		</div>
		<div class="h-panel-body padding">
			<table class="cus-table">
				<thead class="header">
				<tr v-if="!isUnit">
					<td width="150">科目编码</td>
					<td nowrap>科目名称</td>
					<td width="100" nowrap>余额方向</td>
					<td width="150">期初余额</td>
					<td width="150">借方累计</td>
					<td width="150">贷方累计</td>
					<td width="150">年初余额</td>
				</tr>
				<template v-else>
					<tr>
						<td width="150" rowspan="2">科目编码</td>
						<td rowspan="2" nowrap>科目名称</td>
						<td width="100" rowspan="2" nowrap>余额方向</td>
						<td width="70" rowspan="2" nowrap>单位</td>
						<td colspan="2">期初余额</td>
						<td colspan="2">借方累计</td>
						<td colspan="2">贷方累计</td>
						<td colspan="2">年初余额</td>
					</tr>
					<tr>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
					</tr>
				</template>
				</thead>
				<tbody>
				<tr v-for="(item,i) in datas" :key="i">
					<td :style="{paddingLeft:(item.level!=1?(item.level-1)*20:10)+'px'}">{{item.code}}</td>
					<td nowrap>
						{{item.name}} <i @click="addDetails(item)" class="fa fa-plus text-hover" v-if="item.auxiliaryAccounting" v-tooltip content="点击+号<br/>添加辅助明细"></i>
					</td>
					<td class="text-center">{{item.balanceDirection}}</td>
					<td class="text-center" v-if="isUnit">{{item.unit}}</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._numEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._numEdit" @dblclick="showInput($event,item,'_numEdit',i)">{{item.num|numFormat}}</div>
							<NumberInput :id="'_numEdit'+i" v-width="130" v-if="item._numEdit" v-model="item.num" @change="balanceChange(item,'_numEdit')"/>
						</template>
						<template v-else>
							{{item.num|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._edit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock balance-edit-block" :data-code="item.code" :data-num="item.beginBalance" v-if="!item._edit" @dblclick="showInput($event,item,'_edit',i)">{{item.beginBalance|numFormat}}</div>
							<NumberInput :id="'_edit'+i" v-width="130" v-if="item._edit" v-model="item.beginBalance" @change="balanceChange(item,'_edit')"/>
						</template>
						<template v-else>
							<span class="balance" :data-code="item.code" :data-index="i">{{item.beginBalance|numFormat}}</span>
						</template>
					</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._cumulativeDebitNumEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._cumulativeDebitNumEdit" @dblclick="showInput($event,item,'_cumulativeDebitNumEdit',i)">{{item.cumulativeDebitNum|numFormat}}</div>
							<NumberInput :id="'_cumulativeDebitNumEdit'+i" v-width="130" v-if="item._cumulativeDebitNumEdit" v-model="item.cumulativeDebitNum" @change="balanceChange(item,'_cumulativeDebitNumEdit')"/>
						</template>
						<template v-else>
							{{item.cumulativeDebitNum|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._cumulativeDebitEdit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock debit-edit-block" :data-code="item.code" :data-num="item.cumulativeDebit" v-if="!item._cumulativeDebitEdit" @dblclick="showInput($event,item,'_cumulativeDebitEdit',i)">{{item.cumulativeDebit|numFormat}}</div>
							<NumberInput :id="'_cumulativeDebitEdit'+i" v-width="130" v-if="item._cumulativeDebitEdit" v-model="item.cumulativeDebit" @change="balanceChange(item,'_cumulativeDebitEdit')"/>
						</template>
						<template v-else>
							<span class="debit" :data-code="item.code" :data-index="i">{{item.cumulativeDebit|numFormat}}</span>
						</template>
					</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._cumulativeCreditNumEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._cumulativeCreditNumEdit" @dblclick="showInput($event,item,'_cumulativeCreditNumEdit',i)">{{item.cumulativeCreditNum|numFormat}}</div>
							<NumberInput :id="'_cumulativeCreditNumEdit'+i" v-width="130" v-if="item._cumulativeCreditNumEdit" v-model="item.cumulativeCreditNum" @change="balanceChange(item,'_cumulativeCreditNumEdit')"/>
						</template>
						<template v-else>
							{{item.cumulativeCreditNum|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._cumulativeCreditEdit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock credit-edit-block" :data-code="item.code" :data-num="item.cumulativeCredit" v-if="!item._cumulativeCreditEdit" @dblclick="showInput($event,item,'_cumulativeCreditEdit',i)">{{item.cumulativeCredit|numFormat}}</div>
							<NumberInput :id="'_cumulativeCreditEdit'+i" v-width="130" v-if="item._cumulativeCreditEdit" v-model="item.cumulativeCredit" @change="balanceChange(item,'_cumulativeCreditEdit')"/>
						</template>
						<template v-else>
							<span class="credit" :data-code="item.code" :data-index="i">{{item.cumulativeCredit|numFormat}}</span>
						</template>
					</td>
					<td class="text-center" v-if="isUnit">
						{{item.cumulativeCreditNum|numFormat}}
					</td>
					<td class="text-right">
						{{(item.beginBalance-(item.cumulativeDebit||0)+(item.cumulativeCredit||0))|numFormat}}
					</td>
				</tr>
				<tr v-if="datas.length" class="total-row">
				<td :colspan="isUnit ? 4 : 3">合计</td>
				<td v-if="isUnit"></td>
				<td>
					<div>借：{{totals.begin.debit|numFormat}}</div>
					<div>贷：{{totals.begin.credit|numFormat}}</div>
				</td>
				<td v-if="isUnit"></td>
				<td>
					<div>借：{{totals.dDebit.debit|numFormat}}</div>
					<div>贷：{{totals.dDebit.credit|numFormat}}</div>
				</td>
				<td v-if="isUnit"></td>
				<td>
					<div>借：{{totals.dCredit.debit|numFormat}}</div>
					<div>贷：{{totals.dCredit.credit|numFormat}}</div>
				</td>
				<td v-if="isUnit"></td>
				<td>
					<div>借：{{totals.year.debit|numFormat}}</div>
					<div>贷：{{totals.year.credit|numFormat}}</div>
				</td>
			</tr>
			<tr v-if="!datas.length">
				<td colspan="8" class="text-center padding">暂无数据</td>
			</tr>
				</tbody>
			</table>
		</div>
		<div class="text-right" style="padding: 0 15px 10px">
			<Button color="red" @click="saveAll">保存变更</Button>
		</div>
		<Modal v-model="showModal" hasCloseIcon hasDivider>
			<div slot="header">期初试算结果</div>
			<Row class="result">
				<Cell :width="12" class="text-center" style="border-right: 1px solid #eeeeee">
					<div class="font-bold margin">期初余额</div>
					<div class="pic-body beginningBalance" :class="{left:beginningBalance.借<beginningBalance.贷,right:beginningBalance.借>beginningBalance.贷}">
						<span class="span1">{{beginningBalance.借|numFormat}}</span>
						<span class="span2">{{beginningBalance.借-beginningBalance.贷|numFormat}}</span>
						<span class="span3">{{beginningBalance.贷|numFormat}}</span>
						<div class="pic"></div>
					</div>
				</Cell>
				<Cell :width="12" class="text-center">
					<div class="font-bold margin">资产负债表期初</div>
					<div class="pic-body liabilities" :class="{left:liabilities.资产<liabilities.权益,right:liabilities.资产>liabilities.权益}">
						<span class="span1">{{liabilities.资产|numFormat}}</span>
						<span class="span2">{{liabilities.资产-liabilities.权益|numFormat}}</span>
						<span class="span3">{{liabilities.权益|numFormat}}</span>
						<div class="pic "></div>
					</div>
				</Cell>
			</Row>
		</Modal>
		<Modal v-model="showDetailModal" hasCloseIcon hasDivider>
			<div slot="header">增加明细</div>
			<Form v-width="400" :labelWidth="60" class="padding-right margin-top">
				<FormItem label="科目">
					<Select @change="subjectChange" v-model="auxiliary.subjectId" :datas="auxiliarys" :deletable="false" titleName="name" keyName="subjectId"></Select>
				</FormItem>
				<FormItem v-for="item in auxiliaryAccounting" :label="item.name" :key="item.id">
					<Select v-model="auxiliary.auxiliary[item.id]" :datas="auxiliaryAccountingData[auxiliary.subjectId]?auxiliaryAccountingData[auxiliary.subjectId][item.id]:[]" :deletable="false" titleName="name" keyName="id">
						<template slot-scope="{item}" slot="item">{{item.code}}-{{item.name}}</template>
					</Select>
				</FormItem>
			</Form>
			<div class="text-center margin-top">
				<Button color="green" @click="saveAuxiliary" :loading="loading">增加</Button>
				<Button @click="showDetailModal=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="importForm.show" :width="520">
			<div slot="header">财务期初余额导入</div>
			<div class="padding">
				<div class="imp-step">第一步：请点击下面的链接下载 Excel 模板，并按照模板填写信息</div>
				<a :href="templateUrl" class="imp-link">下载模板</a>
				<div class="imp-step">第二步：导入 Excel 模板文件</div>
				<div>
					<span class="imp-link" @click="selectImportFile">选取文件</span>
					<span v-if="importForm.fileName" class="imp-filename">{{importForm.fileName}}</span>
				</div>
				<div class="imp-tip">* 导入按科目编码更新期初余额；不存在的科目、非末级科目、挂辅助核算的科目将被跳过。如需重新整理，建议先点"清空"再导入。</div>
				<input ref="importFile" type="file" accept=".xls,.xlsx" style="display:none" @change="importFileChange($event)">
			</div>
			<div class="text-center">
				<Button @click="importForm.show=false">取消</Button>
				<Button color="primary" :loading="loading" @click="doImport">导入</Button>
			</div>
		</Modal>
		<Modal v-model="cashFlowForm.show" :width="900">
			<div slot="header">现金流期初</div>
			<div class="cashflow-initial-box">
				<table class="cf-table">
					<thead>
					<tr>
						<td>名称</td>
						<td width="80" class="text-center">行号</td>
						<td width="220" class="text-center">本年累计金额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="row in cfViewRows" :key="row.id" :class="row._kind">
						<td>
							<span v-if="row._kind==='group'" class="cf-fold" @click="toggleGroup(row)">{{row._collapsed?'▶':'▼'}}</span>
							<span :style="{paddingLeft:(row._kind==='input'?28:8)+'px'}">{{row.title}}</span>
						</td>
						<td class="text-center">{{row.lineNum}}</td>
						<td class="text-right">
							<input v-if="row._kind==='input'" type="text" class="cf-input" v-model="cashFlowForm.amounts[row.id]" placeholder="请输入">
							<span v-else>{{row._auto|numFormat}}</span>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center" style="padding: 10px 0">
				<Button color="primary" :loading="loading" @click="saveCashFlowData">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex';
	import jQuery from 'jquery';

	const emptyForm = {
		"id": "0",
		"code": "",
		"name": "",
		"mnemonicCode": "",
		"balanceDirection": "",
		"status": "0",
		"parentId": "0"
	};

	export default {
		name: "Initial",
		data() {
			return {
				tabDatas: [
					{
						title: '资产',
						key: 'CodeAssets'
					}, {
						title: '负债',
						key: 'CodeLiabilities'
					}, {
						title: '权益',
						key: 'CodeInterest'
					}, {
						title: '成本',
						key: 'CodeCost'
					}, {
						title: '损益',
						key: 'CodeLoss'
					}],
				type: '资产',
				datas: [],
				form: Object.assign({}, emptyForm),
				showForm: false,
				showDetailModal: false,
				selected: 'CodeAssets',
				showModal: false,
				loading: false,
				temps: {},
				auxiliary: {subjectId: "", auxiliary: {}},
				auxiliaryAccounting: [],
				auxiliaryAccountingData: {},
				beginningBalance: {借: 0, 贷: 0},
			liabilities: {权益: 0, 资产: 0},
			importForm: {show: false, fileName: ''},
			cashFlowForm: {show: false, rows: [], amounts: {}},
			totals: {
				begin: {debit: 0, credit: 0},
				dDebit: {debit: 0, credit: 0},
				dCredit: {debit: 0, credit: 0},
				year: {debit: 0, credit: 0}
			}
		};
	},
	computed: {
		...mapState(['currentAccountSets']),
		isUnit() {
			return this.datas.filter(value => value.unit).length > 0;
		},
		auxiliarys() {
			return this.datas.filter(value => value.auxiliaryAccounting)
		},
		templateUrl() {
			return this.$api.setting.initialBalance.templateUrl();
		},
		cfViewRows() {
			let result = [];
			let hide = false;
			this.cashFlowForm.rows.forEach(row => {
				if (row._kind === 'group') {
					hide = !!row._collapsed;
					result.push(row);
				} else if (!hide) {
					result.push(row);
				}
			});
			return result;
		}
	},
		watch: {
			type() {
				this.loadList();
			}
		},
		methods: {
			showInput(e, item, type, i) {
				this.$set(item, type, true);
				this.$nextTick(() => {
					jQuery('.h-input', '#' + type + i).focus().select()
				});
			},
			addDetails(item) {
				this.auxiliary.subjectId = item.subjectId;
				this.subjectChange(item);
				this.showDetailModal = true;
			},
			addTemp(data) {
				this.temps[data.id] = data;
				return data.id;
			},
			loadList() {
				this.loading = true;
				this.$api.setting.initialBalance.list(this.type).then(({data}) => {
					this.datas = data;
					this.loading = false;

					this.$nextTick(this.calParent);
				})
			},
			calParent() {
				let cals = {'balance': 'beginBalance', 'debit': 'cumulativeDebit', 'credit': 'cumulativeCredit'};
				Object.keys(cals).forEach(key => {
					jQuery(`span.${key}`).each((i, item) => {
						let {code, index} = item.dataset;
						let total = 0;
						jQuery(`.${key}-edit-block[data-code^=${code}]`).each((i, numItem) => {
							if (numItem.dataset.num) {
								total += Number(numItem.dataset.num)
							}
						});
						this.datas[index][cals[key]] = total;
					});
				});

				this.datas = Array.from(this.datas);
				this.calTotals();
			},
			calTotals() {
				let begin = {debit: 0, credit: 0};
				let dDebit = {debit: 0, credit: 0};
				let dCredit = {debit: 0, credit: 0};
				let year = {debit: 0, credit: 0};
				this.datas.forEach(item => {
					//挂辅助核算的科目行金额已体现在辅助明细行中，跳过
					if (item.leaf && !item.auxiliaryAccounting) {
						let b = item.beginBalance || 0;
						if (item.balanceDirection === '借') {
							begin.debit += b;
						} else {
							begin.credit += b;
						}
						dDebit.debit += item.cumulativeDebit || 0;
						dCredit.credit += item.cumulativeCredit || 0;
						let y = b - (item.cumulativeDebit || 0) + (item.cumulativeCredit || 0);
						if (item.balanceDirection === '借') {
							year.debit += y;
						} else {
							year.credit += y;
						}
					}
				});
				this.totals = {begin, dDebit, dCredit, year};
			},
			change(data) {
				this.type = data.title;
			},
			balanceChange(balance, target) {
				let params = {
					summary: "期初",
					subjectName: `${balance.code}-${balance.name}`,
					subjectCode: balance.code,
					subjectId: balance.subjectId,
					accountSetsId: balance.accountSetsId,
					cumulativeCredit: balance.cumulativeCredit,
					cumulativeDebit: balance.cumulativeDebit,
					cumulativeDebitNum: balance.cumulativeDebitNum,
					cumulativeCreditNum: balance.cumulativeCreditNum,
					num: balance.num
				};

				if (balance.balanceDirection === '借') {
					params.debitAmount = balance.beginBalance;
				} else {
					params.creditAmount = balance.beginBalance;
				}
				this.$api.setting.initialBalance.save(params).then(({data}) => {
					this.$set(balance, target, false);
					this.$nextTick(this.calParent);
				});
			},
			trialBalance() {
				this.$api.setting.initialBalance.trialBalance().then(({data}) => {
					this.showModal = true;
					this.beginningBalance = Object.assign(this.beginningBalance, data.beginningBalance);
					this.liabilities = Object.assign(this.liabilities, data.liabilities);
				});
			},
			subjectChange(subject) {
				this.auxiliaryAccounting = JSON.parse(subject.auxiliaryAccounting);
				this.loadAuxiliaryAccountingData(subject);
			},
			loadAuxiliaryAccountingData(subject) {
				if (!this.auxiliaryAccountingData[subject.subjectId]) {
					this.$api.setting.accountingCategoryDetails.loadAuxiliaryAccountingData(this.auxiliaryAccounting).then(({data}) => {
						this.$set(this.auxiliaryAccountingData, subject.subjectId, data);
					});
				}
			},
			saveAuxiliary() {
			if (this.auxiliary.subjectId && Object.keys(this.auxiliary.auxiliary).length === this.auxiliaryAccounting.length) {
				this.loading = true;
				this.$api.setting.initialBalance.saveAuxiliary(this.auxiliary).then(({data}) => {
					this.loadList();
					this.showDetailModal = false;
				}).finally(() => {
					this.loading = false;
				});
			}
		},
		openImport() {
			this.importForm.fileName = '';
			if (this.$refs.importFile) {
				this.$refs.importFile.value = '';
			}
			this.importForm.show = true;
		},
		selectImportFile() {
			this.$refs.importFile.click();
		},
		importFileChange(e) {
			if (e.target.files.length) {
				this.importForm.fileName = e.target.files[0].name;
			}
		},
		doImport() {
			if (!this.importForm.fileName) {
				this.$Message('请先选取要导入的 Excel 文件');
				return;
			}
			let file = this.$refs.importFile.files[0];
			let formData = new FormData();
			formData.append('file', file);
			this.loading = true;
			this.$api.setting.initialBalance.importExcel(formData).then(({data}) => {
				this.$Message(`导入完成，成功 ${data.success} 个科目，跳过 ${data.skip} 个`);
				this.importForm.show = false;
				this.loadList();
			}).finally(() => {
				this.loading = false;
			});
		},
		exportData() {
			window.open(this.$api.setting.initialBalance.exportUrl(this.type));
		},
		clearData() {
			this.$Confirm('确认清空全部科目的期初余额？该操作不可恢复，且不影响已录入凭证。').then(() => {
				this.loading = true;
				this.$api.setting.initialBalance.clear().then(() => {
					this.$Message('期初余额已清空~');
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			});
		},
		saveAll() {
			this.$api.setting.initialBalance.trialBalance().then(({data}) => {
				let bb = data.beginningBalance;
				let diff = (bb.借 || 0) - (bb.贷 || 0);
				if (Math.abs(diff) < 0.01) {
					this.$Message('期初数据借贷平衡，保存成功~');
				} else {
					this.$Message('期初借贷不平衡，差额：' + diff.toFixed(2) + '，请检查后再保存');
				}
			});
		},
		openCashFlow() {
			this.loading = true;
			this.$api.setting.initialBalance.cashFlowItems().then(({data}) => {
				let amounts = {};
				Object.keys(data.amounts || {}).forEach(id => {
					amounts[id] = data.amounts[id];
				});
				this.cashFlowForm.amounts = amounts;
				this.cashFlowForm.rows = this.buildCashFlowRows(data.items || [], amounts);
				this.cashFlowForm.show = true;
			}).finally(() => {
				this.loading = false;
			});
		},
		cashFlowKind(row) {
			let title = row.title || '';
			let bold = row.isBolder === true;
			if (bold && /净增加额/.test(title)) {
				return 'sum';
			}
			if (bold && /期末现金余额/.test(title)) {
				return 'sum';
			}
			if (bold) {
				return 'group';
			}
			if (/小计/.test(title)) {
				return 'sum';
			}
			if (/净额/.test(title)) {
				return 'net';
			}
			if (/净增加额|期末现金余额/.test(title)) {
				return 'sum';
			}
			return 'input';
		},
		buildCashFlowRows(items, amounts) {
			let rows = items.map(item => {
				let row = Object.assign({}, item);
				row._kind = this.cashFlowKind(row);
				row._auto = 0;
				row._collapsed = false;
				return row;
			});
			this.computeCashFlowAuto(rows, amounts);
			return rows;
		},
		computeCashFlowAuto(rows, amounts) {
			let pendingIn = 0;
			let pendingOut = 0;
			let subIn = null;
			let subOut = null;
			let netSum = 0;
			let netIncrease = 0;
			let beginCash = 0;

			rows.forEach(row => {
				let title = row.title || '';
				if (row._kind === 'group') {
					pendingIn = 0;
					pendingOut = 0;
					subIn = null;
					subOut = null;
				} else if (row._kind === 'input') {
					let v = parseFloat(amounts[row.id]) || 0;
					if (/期初现金余额/.test(title)) {
						beginCash = v;
					} else if (/收到|收回/.test(title)) {
						pendingIn += v;
					} else {
						pendingOut += v;
					}
				} else if (row._kind === 'sum') {
					if (/流入小计/.test(title)) {
						row._auto = pendingIn;
						subIn = pendingIn;
						pendingIn = 0;
					} else if (/流出小计/.test(title)) {
						row._auto = pendingOut;
						subOut = pendingOut;
						pendingOut = 0;
					} else if (/净增加额/.test(title)) {
						row._auto = netSum;
						netIncrease = netSum;
					} else if (/期末现金余额/.test(title)) {
						row._auto = netIncrease + beginCash;
					}
				} else if (row._kind === 'net') {
					let val = (subIn != null ? subIn : pendingIn) - (subOut != null ? subOut : pendingOut);
					row._auto = val;
					netSum += val;
				}
			});
		},
		toggleGroup(row) {
			this.$set(row, '_collapsed', !row._collapsed);
		},
		saveCashFlowData() {
			let amounts = {};
			let invalid = false;
			this.cashFlowForm.rows.filter(r => r._kind === 'input').forEach(r => {
				let raw = this.cashFlowForm.amounts[r.id];
				if (raw === undefined || raw === '') {
					return;
				}
				let v = parseFloat(raw);
				if (isNaN(v)) {
					invalid = true;
				} else {
					amounts[r.id] = v;
				}
			});
			if (invalid) {
				this.$Message('存在不是数字的金额，请检查');
				return;
			}
			this.loading = true;
			this.$api.setting.initialBalance.saveCashFlow({amounts}).then(() => {
				this.$Message('现金流量期初保存成功~');
				this.cashFlowForm.show = false;
			}).finally(() => {
				this.loading = false;
			});
		}
	},
		mounted() {
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
			}
			this.loadList();
		}
	};
</script>
<style lang="less" scoped>
	.result {
		width: 500px;
		height: 250px;

		.pic {
			width: 238px;
			height: 120px;
			background-image: url("../../assets/settings.png");
			background-repeat: no-repeat;
			margin: 20px auto;
		}


		.pic-body {
			margin-top: 50px;
			position: relative;

			&.beginningBalance {
				.pic {
					background-position: -160px 0px;
				}

				span {
					position: absolute;
				}

				.span1 {
					top: 0;
					left: 22px;
				}

				.span2 {
					top: 50px;
					left: 0;
					width: 100%;
				}

				.span3 {
					top: 0;
					right: 10px;
				}

				&.right {
					.pic {
						height: 130px;
						background-position: -160px -132px;
					}

					.span1 {
						top: 25px;
					}

					.span3 {
						top: -25px;
					}
				}

				&.left {
					.pic {
						height: 130px;
						background-position: -160px -272px;
					}

					.span1 {
						top: -25px;
					}

					.span3 {
						top: 25px;
					}
				}
			}

			&.liabilities {
				.pic {
					background-position: -420px 5px;
				}

				span {
					position: absolute;
				}

				.span1 {
					top: 0;
					left: 22px;
				}

				.span2 {
					top: 50px;
					left: 0;
					width: 100%;
				}

				.span3 {
					top: 0;
					right: 10px;
				}

				&.right {
					.pic {
						height: 130px;
						background-position: -420px -132px;
					}

					.span1 {
						top: 25px;
					}

					.span3 {
						top: -25px;
					}
				}

				&.left {
					.pic {
						height: 130px;
						background-position: -420px -272px;
					}

					.span1 {
						top: -25px;
					}

					.span3 {
						top: 25px;
					}
				}
			}
		}
	}

	.editblock {
		width: 100%;
		height: 100%;
		line-height: 33px;
	}

	.edit-hover:hover {
		cursor: pointer;
		background-color: @gray2-color;
	}

	.total-row {
		font-weight: bold;
		background: #fafafa;

		td {
			vertical-align: middle;
		}
	}

	.imp-step {
		color: #333;
		line-height: 2;
	}

	.imp-link {
		color: #1890ff;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}

	.imp-filename {
		margin-left: 10px;
		color: #666;
	}

	.imp-tip {
		margin-top: 15px;
		color: #999;
		font-size: 12px;
		line-height: 1.8;
	}

	.cashflow-initial-box {
		max-height: 500px;
		overflow-y: auto;
		border: 1px solid #e8e8e8;

		.cf-table {
			width: 100%;
			border-collapse: collapse;

			thead td {
				padding: 10px;
				font-weight: bold;
				background: #fafafa;
				border-bottom: 1px solid #e8e8e8;
			}

			td {
				padding: 8px 10px;
				border-bottom: 1px solid #f0f0f0;
			}

			tr.group td {
				font-weight: bold;
				background: #fafafa;
			}

			tr.net td {
				font-weight: bold;
			}
		}

		.cf-fold {
			display: inline-block;
			width: 18px;
			color: #666;
			cursor: pointer;
		}

		.cf-input {
			width: 180px;
			height: 28px;
			padding: 0 8px;
			border: 1px solid #d9d9d9;
			border-radius: 4px;
			text-align: right;
		}
	}
</style>
